// Centralise Firebase Web configuration for the frontend
// Values are expected from environment variables prefixed with VUE_APP_
// or can be injected at runtime via window.__FIREBASE_CONFIG__.

const runtimeConfig = (typeof window !== 'undefined' && window.__FIREBASE_CONFIG__) || {};

export const firebaseConfig = {
  apiKey: runtimeConfig.apiKey || process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: runtimeConfig.authDomain || process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  projectId: runtimeConfig.projectId || process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: runtimeConfig.storageBucket || process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: runtimeConfig.messagingSenderId || process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: runtimeConfig.appId || process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: runtimeConfig.measurementId || process.env.VUE_APP_FIREBASE_MEASUREMENT_ID,
};

export const firebaseVapidKey = runtimeConfig.vapidKey || process.env.VUE_APP_FIREBASE_VAPID_KEY;

export function isFirebaseConfigValid() {
  return Boolean(
    firebaseConfig &&
    firebaseConfig.apiKey &&
    firebaseConfig.projectId &&
    firebaseConfig.messagingSenderId &&
    firebaseConfig.appId &&
    firebaseVapidKey
  );
}


